/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useTranslation } from "react-i18next";
import ProductCarousel from "./ProductCarousel";
import ProductTitleVideo from "./ProductTitleVideo";
import ProductShare from "./ProductShare";
import ProductDesc from "./ProductDesc";
import SimilarProductsDynamic from "../common/SimilarProductsDynamic";

function UltraKivamliCamasirSuyu() {
const [activeIndex, setActiveIndex] = useState(0);

const handleSelect = (selectedIndex) => {
setActiveIndex(selectedIndex);
};

const handlePrev = () => {
handleSelect(activeIndex === 0 ? 5 : activeIndex - 1);
};

const handleNext = () => {
handleSelect(activeIndex === 5 ? 0 : activeIndex + 1);
};

const { t } = useTranslation();

const [expanded, setExpanded] = useState(false);

const toggleNav = () => {
setExpanded(!expanded);
};

const handleClick = () => {
window.scrollTo(0, 0);
setExpanded(false);
};

const customProducts = [
{
"picture": "assets/images/20-kg/2.webp",
"nav": "/camasirsuyu",
"title": "Çamaşır Suyu"
}
]

return (
<>
    <SRLWrapper>
        <section class="product-details section-space">
            <div class="container">
                <div class="row gutter-y-50">
                    <div class="col-lg-6 col-xl-6 wow fadeInLeft" data-wow-delay="200ms">
                        <div class="product-details__img">
                            <div class="swiper product-details__gallery-top p-5">
                                <div className="album-list-item">
                                    <Link className="ali-link" onClick={handleClick} as={Link} to="/Armur">
                                    <div className="ali-img-wrap">
                                        <div>
                                            <img className="img-fluid blur-up lazyload" src="assets/images/20-kg/3.webp"
                                                alt="image" title="image" />
                                        </div>
                                    </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-6 wow fadeInRight" data-wow-delay="300ms">
                        <div class="product-details__content">
                            <div
                                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                                <ProductTitleVideo title="Ultra Kıvamlı Çamaşır Suyu" video="" />
                                <span className="product-details__weight"
                                    style={{fontSize: '16px', fontWeight: 'bold', color: '#10adad'}}>
                                    5 KG - 20 KG
                                </span>
                            </div>
                            <div class="product-details__excerpt">
                                <h4 class="mt-4 mb-3">ÖZELLİKLERİ</h4>
                                <ul class="product-details__list">
                                    <li>Yüzeylerin temizlenmesinde ve dezenfekte edilmesinde kullanılır.</li>
                                    <li>Zor kirleri ve yağları söker, ferah bir koku bırakır.</li>
                                    <li>Formülünde çamaşır suyu katkısı ile tüm yüzeylerde güvenli temizlik ve hijyen
                                        sağlar.</li>
                                    <li>Yer karosu, kapı, fırın, fayans ve seramik yüzeylerin temizlenmesi ve dezenfekte
                                        edilmesinde kullanılır.</li>
                                </ul>

                                <h4 class="mt-4 mb-3">ÜRÜN BİLEŞİMİ</h4>
                                <p class="product-details__description__text">
                                    Aktif klor bileşiği %15-30, Anyonik aktif madde %5-15, stabilizatör %1-5, esans
                                    içerir.
                                </p>
                            </div>

                            <div class="product-details__buttons">
                                <Link as={Link} to="/urunlerimiz" class="product-details__btn boskery-btn">
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__hover"></span>
                                <span class="boskery-btn__text">
                                    {" "}
                                    DİĞER ÜRÜNLERİMİZ
                                </span>
                                <i class="icon-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-details__description-wrapper">
                <div class="container">
                    <div class="product-details__description">
                        <h3 class="product-details__description__title">
                            Ürün Detayları
                        </h3>
                        <div class="product-details__text__box wow fadeInUp" data-wow-delay="300ms">

                            <h4 class="mt-4 mb-3">KULLANIM ŞEKLİ VE MİKTARI</h4>
                            <ul class="product-details__list">
                                <li>Sulandırılarak 1 lt suya 10-15 gr Dexpur ilave edilerek kullanılır.</li>
                                <li>Sulandırmadan doğrudan bez üzerine Dexpur dökülerek lavabo, evye, fayans ve
                                    küvetlerdeki ağır lekeler temizlenir.</li>
                            </ul>

                            <div class="alert alert-info mt-4 p-4 text-white" style={{ backgroundColor: "#10adad" }}>

                                <h6><strong>TÜKETİCİNİN DİKKATİNE:</strong></h6>
                                <ul class="mb-0">
                                    <li>Tahriş edicidir. Kullanırken eldiven giyiniz. Asitlerle temasından zehirli gaz
                                        çıkarır.</li>
                                    <li>Cilt ve göz temasından kaçınınız. Cilt ve göz temasında derhal bol su ile yıkayınız.
                                        Ambalaj tamamen boşaldıktan sonra geri dönüşüm işlemine gönderiniz.
                                    </li>
                                    <li>Yutulması halinde sağlığa zararlıdır. Herhangi bir hassasiyet meydana gelirse
                                        doktora başvurunuz. 5°C'nin altında ve 35°C'nin üstündeki sıcaklıklarda ve direkt
                                        güneş ışığında bırakmayınız.</li>
                                    <li>Başka bir ürün ve madde ile karıştırmayınız. Kapağını kapalı tutunuz. Kullanma
                                        talimatını mutlaka okuyunuz. Kapakta bulunan emniyet pimi kırılmış bidonları satın almayınız.</li>
                                    <li>Gıda maddelerinden ve çocuklardan uzak tutunuz. Zehirlenme durumunda Ulusal
                                        Zehir Danışma Merkezi'nin (UZEM) 114 numaralı telefonunu veya Acil Sağlık
                                        Hizmetleri'nin 112 numaralı telefonunu arayınız.</li>
                                    <li>Dexpur yanlış kullanım ve saklamadan doğacak zarardan sorumlu
                                        değildir.</li>
                                </ul>
                            </div>

                            <div class="product-info-box mt-4 p-3 bg-light">
                                <h6><strong>📋 TEKNİK BİLGİLER:</strong></h6>
                                <div class="row">
                                    <p><strong>Net Ağırlık:</strong> 5 KG VE 20 KG Seçenekleri mevcuttur.</p>
                                    <p><strong>Üretici Firma :</strong> Seymen Kimya Temizlik San. ve Tic. Ltd. Şti.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    </SRLWrapper>

    <SimilarProductsDynamic products={customProducts} handleClick={handleClick} />
</>
);
}

export default UltraKivamliCamasirSuyu;